module.exports = __webpack_public_path__ + "static/media/ic_note.6cf11bb0.svg";